<script lang="ts">
    import {onMount} from "svelte";
    import LoadingView from "./LoadingView.svelte";
    import {MessageStore} from "../../../store/MessageStore";


    onMount(() => {
    });

    $: fullScreenMessage = MessageStore.fullScreenMessage;
    $: isShow = (() => {
        if ($fullScreenMessage != null) {
            return true;
        } else {
            return false;
        }
    })();


</script>

<div class="full-screen-loading-view"
     class:show={isShow}
>
    {#if $fullScreenMessage != null}
        <div class="content-area">
            <div class="message">
                <LoadingView/>
                { $fullScreenMessage.message }
                <LoadingView/>
            </div>
            <div class="description">
                { $fullScreenMessage.description }
            </div>
        </div>
    {/if}

</div>
<style lang="scss">
    .full-screen-loading-view {
        z-index: var(--full-screen-loading-view-z-index);

        pointer-events: none;

        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        transition: 0.5s;

        color: #fff;

        padding-top: 30px;

        display: flex;
        align-items: center;
        justify-content: center;

        .content-area {
            .message {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 40px;
                min-height: 40px;
            }

            .description {
                text-align: center;
                opacity: 0.75;
                font-size: 16px;

            }

        }


        &.show {
            pointer-events: all;
            background-color: #0009;
        }


    }
</style>